module.exports = __webpack_public_path__ + "static/media/186-dominica.e1367692.svg";